module.exports = __webpack_public_path__ + "media/helicopter_loop.5a23139d.mp3";